import { Nft } from "@/api/nfts/types";
import { BaseSignedOrder } from "@/api/orders/types";

import { isEqual } from "@/shared/string";
import { BuyNowButton } from "../Buttons/BuyNow";
import { isReserveAuction } from "./helpers";
import { BuyerReserveActions } from "./BuyerReserveActions";
import SellerTradeActions from "./SellerTradeActions/SellerTradeActions";
import useMe from "@/shared/hooks/useMe";

export interface Props {
  nft: Nft;
  auction: BaseSignedOrder;
  disable?: boolean;
}

export default function TradeActions({ nft, auction, disable }: Props) {
  const { me } = useMe();

  return isEqual(me?.address, nft.owner.address) ? (
    <SellerTradeActions nft={nft} auction={auction} />
  ) : isReserveAuction(auction) ? (
    <BuyerReserveActions nft={nft} auction={auction} disable={disable} />
  ) : (
    <BuyNowButton nft={nft} auction={auction} disable={disable} />
  );
}
